"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var styles_2 = require("../styles");
var useStyles = (0, styles_1.makeStyles)(function (_a) {
    var palette = _a.palette;
    return ({
        contentDividers: {
            borderTopColor: (0, styles_2.getTitleColor)(palette),
            borderBottomColor: palette.grey[200]
        }
    });
});
exports.default = useStyles;
